module.exports = __webpack_public_path__ + "assets/img/20220509-4.55db498c.png";